
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./home.css";
import heroImage from '../../assets/images/Home/hero.webp'; // Adjust path to your folder

const HomeHero = () => {
  useEffect(() => {
    // Hero scale on scroll
    const handleScroll = () => {
      const hero = document.querySelector(".hero");
      if (window.scrollY > 100) {
        hero.style.transform = "scale(0.95)";
        hero.style.transition = "0.5s ease";
      } else {
        hero.style.transform = "scale(1)";
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Ripple effect on click
  const handleRippleClick = (e) => {
    const button = e.currentTarget;
    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${e.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${e.clientY - button.offsetTop - radius}px`;
    circle.classList.add("ripple");
    button.appendChild(circle);
    setTimeout(() => circle.remove(), 600);
  };

  // Smooth redirect
  const smoothRedirect = (e, url) => {
    e.preventDefault();
    document.body.classList.add("fade-out");
    setTimeout(() => {
      window.location.href = url;
    }, 600);
  };


   const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: 'Al Taj Chiller Van Rental',
        text: 'Check out the best refrigerated transport services in UAE!',
        url: window.location.href, // Ye current page ka link share karega
      });
    } catch (error) {
      console.log('Error sharing:', error);
    }
  } else {
    // Agar browser share support nahi karta (desktop), to link copy kar sakte hain
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard!");
  }
};  
  return (
    <section className="hero home-hero overlay container-fluid py-5">
        <img
          src={heroImage}
          alt="Chiller Fleet Transport"
          width="1920"
          height="1080"
          fetchpriority="high"
          loading="eager"
          className="home-hero-bg"
        />
      <div className="container h-100 d-flex justify-content-center align-items-center">
        <div className="home-hero-content">
          <h1>Refrigerated Transport Services in Dubai with Cold Chain Vans & Trucks for Rent | Book Today.</h1>
          <p>Chiller Fleet Transport provides refrigerated transport services in Dubai and the UAE. With a fleet of cold chain vans and trucks available for rent ranging from 1 to 15 tons payload capacity, we cover both light and heavy logistics operations. Our chiller vans (8°C to 0°C) and freezer vans for rent(0°C to -18°C) are used for small to medium-scale deliveries where consistent temperature control is required.</p>

          <p>For larger loads, we provide chiller trucks, freezer trucks, and refrigerated truck rental options used for high-volume logistics, including food distribution, dairy supply chains, meat and poultry transport, and consolidated warehouse shipments across Dubai and the UAE. Each vehicle category is assigned based on load size and product requirement to maintain proper transport conditions throughout the journey.</p>

          <p>Book your temperature-controlled van or Truck in Dubai and across the UAE now.</p>
          
          <div className="hero-actions-mini">
            <a href="https://wa.me/971544792905?text=Hi%20I%20want%20to%20book%20a%20service"
              target="_blank"
              rel="noopener noreferrer"
              className="mini-btn primary"
            > Whatsapp Now </a>
            <a
              href="tel:+971544792905"
              className="mini-btn secondary"
            > Call Now </a>
            <button
              onClick={handleShare}
              className="mini-btn primary"
              aria-label="Share this page"
            > Share </button>
          </div>
        </div> 
      </div>
    </section>
  );
};

export default HomeHero;